// @ts-nocheck
import { OmniStyle, html } from 'omni-ui';
import { OmniElementNext } from 'omni-ui/omni-element-next.js';
import 'omni-campaign/src/components/grid-layout/grid-steps.js';

OmniStyle.register();

export default class PreviewCampaignObject extends OmniElementNext {
  static get properties() {
    return {
      object: { type: Object },
      objectType: { type: String },
    };
  }

  render() {
    switch (this.objectType) {
      case 'framework-template':
        return html`
          <omni-style>
            <div class="box is-flex mb-6" style="overflow:auto">
              <campaign-grid-steps
                .data=${{ framework_template: this.object }}
              ></campaign-grid-steps>
            </div>
          </omni-style>
        `;
      default:
        return `Unknown object type: ${this.objectType}`;
    }
  }
}

customElements.define('preview-campaign-object', PreviewCampaignObject);
